import { Panneau } from "../admin/ui.tsx";

/** C3 — Accueil & retrait de badge sur place (bureau, tablette). */
export function Accueil(): React.ReactElement {
  const file = [
    { n: "ADAMCZYK Francis", o: "Distech Controls", s: "préinscrit" as const },
    { n: "Baciu Catherine", o: "invitée · DELABIE", s: "préinscrit" as const },
    { n: "BRAY Jonathan", o: "Comlink", s: "badge émis" as const },
  ];
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 16, maxWidth: 960, alignItems: "start" }}>
      <Panneau titre="Retrait de badge" sous="Point de passage obligatoire : tout visiteur, préinscrit ou invité, retire son badge ici.">
        <div style={{ display: "flex", alignItems: "center", gap: 8, border: "1px solid var(--line-2)", borderRadius: 9, padding: "10px 12px" }}>
          <span style={{ color: "var(--faint)" }}>⌕</span>
          <input placeholder="Nom, e-mail ou organisation du préinscrit…" style={{ border: 0, outline: "none", width: "100%", fontSize: 14, background: "transparent" }} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {file.map((v) => (
            <div key={v.n} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "12px 14px", border: "1px solid var(--line)", borderRadius: 10 }}>
              <div>
                <div style={{ fontWeight: 600 }}>{v.n}</div>
                <div style={{ fontSize: 12.5, color: "var(--muted)" }}>{v.o}</div>
              </div>
              {v.s === "badge émis"
                ? <span className="pill pill-ok" style={{ textTransform: "none", fontFamily: "var(--sans)", fontSize: 12 }}>badge émis</span>
                : <button className="btn btn-primary" style={{ padding: "7px 13px", fontSize: 13 }}>Valider & imprimer</button>}
            </div>
          ))}
        </div>
      </Panneau>

      <Panneau titre="Inscription minute" sous="Un visiteur sans préinscription.">
        <button className="btn btn-primary">Nouveau visiteur sur place</button>
        <p style={{ margin: 0, fontSize: 12.5, color: "var(--muted-2)" }}>Formulaire court ; le badge s'imprime immédiatement.</p>
      </Panneau>
    </div>
  );
}
